import React, { useState } from "react";
import MainApp from "../../../layouts/MainApp";
import ApplicationSettings from "./ApplicationSettings";
import CompanySettings from "./CompanySettings";
import EnhancedApplicationSettings from "./EnhancedApplicationSettings";

const tabs = [
  { name: "Application Settings", href: "application" },
  { name: "Enhanced Application Settings", href: "enhanced-application" },
  { name: "Company Settings", href: "company" },
];

export default function AllApplicationSettings() {
  const [active_tab, setActiveTab] = useState("application");

  const toggle = (tab) => {
    if (active_tab !== tab.href) {
      setActiveTab(tab.href);
    }
  };

  return (
    <MainApp>
      <div className="main-content-padding">
        <div className="main-content">
          <div className="mb-2  d-flex justify-content-between ">
            <h1 className="mr-2">Application Settings</h1>
          </div>
          <div className="mb-5 mx-auto" style={{ maxWidth: "630px" }}>
            <ul className="nav nav-tabs">
              {tabs.map((tab) => (
                <li className="nav-item" key={tab.name}>
                  <button
                    className={
                      "nav-link " +
                      (active_tab === tab.href ? "active font-weight-bold" : "")
                    }
                    onClick={() => toggle(tab)}
                    style={{ cursor: "pointer" }}
                  >
                    {tab.name}
                  </button>
                </li>
              ))}
            </ul>
            {active_tab === "application" && <ApplicationSettings />}
            {active_tab === "company" && <CompanySettings />}
            {active_tab === "enhanced-application" && (
              <EnhancedApplicationSettings />
            )}
          </div>
        </div>
      </div>
    </MainApp>
  );
}
